export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: String,
  },
  emits: ['update:modelValue'],
  methods: {
    onToggle() {
      if (this.disabled) return;
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
